import React from "react";
import Label from "components/Input/Label/Label";
import Checkbox from "components/Input/Checkbox/Checkbox";
import s from "./CheckboxInput.module.scss";
// import { Stack, Typography } from "@mui/material";

/**
 * @param {Object} props
 * @param {Object} inputRef
 * @param {string} props.label
 * @param {string} [props.subLabel]
 * @param {boolean} [props.hideLabel = false]
 * @param {string} [props.emptyLabel = false] 
 * @param {string} [props.secondaryLabel]
 * @param {Function} props.oncheckFn
 * @param {boolean} props.checked
 * @param {React.CSSProperties} [props.divStyle]
 * @param {boolean} [props.disabled = false]
 * @param {boolean} [props.readOnly = false]
 */
const CheckboxInput = ({ inputRef,
  label,
  subLabel,
  hideLabel = false,
  emptyLabel = false,
  oncheckFn, checked,
  divStyle,
  disabled = false,
  readOnly = false,
}) => {
  return (
    <div className={s.checkboxContainer} style={divStyle}>
      <div className={s.checkboxBox}>
        <Checkbox ref={inputRef} disabled={disabled} oncheckFn={oncheckFn} checked={checked} readOnly={readOnly} />
      </div>
      {!hideLabel && <Label label={label} subLabel={subLabel} noBottomMargin empty={emptyLabel} />}
      {/* <Stack sx={{ marginTop: "3px" }} columnGap={1}>
        <Label label={label} noBottomMargin />
        {secondaryLabel && <Typography variant="content-s" color="#666">{secondaryLabel}</Typography>}
      </Stack> */}
    </div>
  );
};

export default React.memo(CheckboxInput);
